import React, { useState, useRef, useEffect } from 'react';
import { debounce, filter, includes, toLower, trim, map } from 'lodash';
import { Tag } from '@zendeskgarden/react-tags';
import {
  Dropdown,
  Menu,
  Multiselect,
  Label,
  Item,
  Field,
} from '@zendeskgarden/react-dropdowns';
import styled from 'styled-components/macro';
import { variables } from 'theme/variables';
import { PropTypes } from 'prop-types';

const { custom_blue: customBlue } = variables;

export const Wrapper = styled.div`
  padding: 10px 5px;
  input {
    height: 20px !important;
  }
`;

export default function MetadataMultiSelect({
  options,
  selectedItems,
  setSelectedItems,
}) {
  const [inputValue, setInputValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [matchingOptions, setMatchingOptions] = useState(options);

  const filterMatchingOptionsRef = useRef(
    debounce((value) => {
      const _matchingOptions = filter(options, (option) =>
        includes(toLower(trim(option.name || '')), toLower(trim(value || '')))
      );

      setMatchingOptions(_matchingOptions);
      setIsLoading(false);
    }, 300)
  );

  useEffect(() => {
    setIsLoading(true);
    filterMatchingOptionsRef.current(inputValue);
  }, [inputValue]);

  const renderOptions = () => {
    if (isLoading) {
      return <Item disabled>Loading items...</Item>;
    }

    if (matchingOptions.length === 0) {
      return (
        <>
          <Item disabled>No matches found</Item>
          <Item
            value={{ label: inputValue, add: true }}
            style={{ color: customBlue }}
            hoverColorLight
          >
            Add Tag: {inputValue}
          </Item>
        </>
      );
    }

    return map(matchingOptions, (option) => (
      <Item key={option.name} value={option}>
        <span>{option.name}</span>
      </Item>
    ));
  };

  return (
    <Wrapper>
      <Dropdown
        inputValue={inputValue || ''}
        selectedItems={selectedItems || []}
        downshiftProps={{
          defaultHighlightedIndex: 0,
          itemToString: (item) => item && item.name,
        }}
        onSelect={(items) => setSelectedItems(items)}
        onStateChange={(changes) => {
          if (Object.prototype.hasOwnProperty.call(changes, 'inputValue')) {
            setInputValue(changes.inputValue);
          }
        }}
      >
        <Field>
          <Label>Content Tags</Label>
          <Multiselect
            style={{ padding: '10px' }}
            isCompact
            renderItem={({ value }) => (
              <Tag>
                <span>{value.name}</span>
              </Tag>
            )}
          />
        </Field>
        <Menu maxHeight="200px" isCompact>
          {renderOptions()}
        </Menu>
      </Dropdown>
    </Wrapper>
  );
}

MetadataMultiSelect.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})),
  // LINT OVERRIDE #8
  // TECH DEBT
  // Array has undetermined elements
  // eslint-disable-next-line react/forbid-prop-types
  selectedItems: PropTypes.array,
  setSelectedItems: PropTypes.func,
};
